export default __webpack_public_path__ + "img/gPASZNDp.52c6ac32.svg";